const translations = {
    cancel: 'Cancel'
};

export default translations;
